import React from "react";

import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <div className="loadingio-spinner-dual-ball-ok04hn58ss8">
        <div className="ldio-q3ofc5j8el">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
